var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"},attrs:{"id":"mainhome"}},[_c('CRow',{staticStyle:{"height":"100%"}},[_c('CCol',{attrs:{"col":"9"}},[_vm._v(" image here ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }